var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35 0.875C1.94844 0.875 0 2.84863 0 5.28125C0 6.66738 0.643438 7.9709 1.74 8.80625L21.46 23.7875C22.4931 24.5678 23.9069 24.5678 24.94 23.7875L30.1419 19.8402C32.3078 14.3508 37.3647 10.3576 43.4003 9.76094L44.66 8.80625C45.7566 7.9709 46.4 6.66738 46.4 5.28125C46.4 2.84863 44.4516 0.875 42.05 0.875H4.35ZM26.68 26.1375C24.6138 27.7072 21.7863 27.7072 19.72 26.1375L0 11.1562V30.25C0 33.4904 2.60094 36.125 5.8 36.125H32.6431C30.3684 33.3344 29 29.7451 29 25.8438C29 25.3297 29.0272 24.8248 29.0725 24.3199L26.68 26.1375ZM58 25.8438C58 18.5459 52.1547 12.625 44.95 12.625C37.7453 12.625 31.9 18.5459 31.9 25.8438C31.9 33.1416 37.7453 39.0625 44.95 39.0625C52.1547 39.0625 58 33.1416 58 25.8438ZM51.0491 21.8689C51.6109 22.4381 51.6109 23.3744 51.0491 23.9436L44.5241 30.5529C43.9622 31.1221 43.0378 31.1221 42.4759 30.5529L38.8509 26.8811C38.2891 26.3119 38.2891 25.3756 38.8509 24.8064C39.4128 24.2373 40.3372 24.2373 40.8991 24.8064L43.5 27.441L49.0009 21.8689C49.5628 21.2998 50.4872 21.2998 51.0491 21.8689Z",
    fill: "url(#paint0_linear_157_846)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_846",
    x1: 58,
    y1: 0.875,
    x2: -1.42387,
    y2: 3.23676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentEmail);
export default __webpack_public_path__ + "static/media/sent-email.bd1fb935786c5b7bcf194268f53dba89.svg";
export { ForwardRef as ReactComponent };